/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EntityEdge } from './EntityEdge';
import {
    EntityEdgeFromJSON,
    EntityEdgeFromJSONTyped,
    EntityEdgeToJSON,
} from './EntityEdge';
import type { EntityNode } from './EntityNode';
import {
    EntityNodeFromJSON,
    EntityNodeFromJSONTyped,
    EntityNodeToJSON,
} from './EntityNode';
import type { EntityType } from './EntityType';
import {
    EntityTypeFromJSON,
    EntityTypeFromJSONTyped,
    EntityTypeToJSON,
} from './EntityType';

/**
 * Optional entity hierarchy [used by: EntityHierarchy]
 * @export
 * @interface EntityHierarchy
 */
export interface EntityHierarchy {
    /**
     * 
     * @type {Array<EntityEdge>}
     * @memberof EntityHierarchy
     */
    edges: Array<EntityEdge>;
    /**
     * 
     * @type {Array<EntityNode>}
     * @memberof EntityHierarchy
     */
    nodes: Array<EntityNode>;
    /**
     * Types to be assigned to individual nodes, providing additional render info per node, potentially empty for single-entity hierarchies
     * @type {Array<EntityType>}
     * @memberof EntityHierarchy
     */
    entityTypes: Array<EntityType>;
}

/**
 * Check if a given object implements the EntityHierarchy interface.
 */
export function instanceOfEntityHierarchy(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "edges" in value;
    isInstance = isInstance && "nodes" in value;
    isInstance = isInstance && "entityTypes" in value;

    return isInstance;
}

export function EntityHierarchyFromJSON(json: any): EntityHierarchy {
    return EntityHierarchyFromJSONTyped(json, false);
}

export function EntityHierarchyFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityHierarchy {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'edges': ((json['edges'] as Array<any>).map(EntityEdgeFromJSON)),
        'nodes': ((json['nodes'] as Array<any>).map(EntityNodeFromJSON)),
        'entityTypes': ((json['entityTypes'] as Array<any>).map(EntityTypeFromJSON)),
    };
}

export function EntityHierarchyToJSON(value?: EntityHierarchy | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'edges': ((value.edges as Array<any>).map(EntityEdgeToJSON)),
        'nodes': ((value.nodes as Array<any>).map(EntityNodeToJSON)),
        'entityTypes': ((value.entityTypes as Array<any>).map(EntityTypeToJSON)),
    };
}

